<template>
  <div
    class="recommendation-detail">
    <vod-item
      :item="recommendation"
      :promo="getPromoInfo(recommendation)"
      :favorite-format="'COVER'"
      :show-title="false"
      tabindex="-1"
      data-wptv="recommendation-item" />
    <div class="recommendation-title">
      {{ recommendation.title }}
    </div>
    <div class="recommendation-type">
      <div v-if="recommendation.type !== 'PACKAGE'">
        {{ genres[0] | capitalizeFLetter }}
      </div>
      <div v-else>
        {{ $t('fip.recommendations.pack_recommendations', { videoCount: recommendation.videoCount }) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VodItem from '../../../../shared/vodItem/VodItem'
import { getPromoInfo } from '../../../../shared/getPromoInfo/getPromoInfo'
export default {
  name: 'FipRecommendationDetail',
  components: { VodItem },
  props: {
    recommendation: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      activatedCoupon: 'user/getActivatedCoupon',
      userDiscounts: 'user/getUserDiscounts',
      articlesIds: 'user/getMyArticlesIds'
    }),
    genres () {
      return this.recommendation.genres ? this.recommendation.genres : []
    }
  },
  methods: {
    getPromoInfo (item) {
      return getPromoInfo(item, this.userDiscounts, this.activatedCoupon, this.articlesIds)
    },
    routerName () {
      if (this.recommendation.videoType === 'MOVIE') {
        return 'film'
      } else if (this.recommendation.type === 'PACKAGE') {
        return 'package'
      } else {
        return 'episode'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .recommendation-detail {
    @extend %focus-visible;
    cursor: pointer;
    width: 115px;
    @include mediaQueries('width', (small:142px, medium: 156px, large: 170px));
    margin-bottom: 20px;

    &:hover {
      color: $primary;
    }

    .recommendation-type, .recommendation-title {
      @include mediaQueries('font-size', (xsmall: 14px, medium: 18px));
      line-height: 1.33;
      word-wrap: break-word;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .recommendation-title {
      font-weight: bold;
      padding-top: 6px;
    }

    .recommendation-type {
      color: $middlegrey;
    }
  }
</style>
